import * as Immutable from 'immutable';
import moment from 'moment';
import * as React from 'react';

interface EventContext {
  currentDate: moment.Moment;
  selectDate: (currentDate: moment.Moment) => { currentDate: moment.Moment };
  data: any;
  isFetching: boolean;
  isFetchingOptions: boolean;
  languageOptions: any;
  eventsOpen: any;
  handleToogleEventsCards: (event: string) => void;
  handleCloseEventsCards: () => void;
  highlightedId: null | string;
  onHighlightFinish: () => void;
}

const Context = React.createContext<EventContext>({
  currentDate: moment(),
  selectDate: (currentDate: moment.Moment) => ({ currentDate }),
  data: Immutable.List(),
  isFetching: false,
  isFetchingOptions: false,
  languageOptions: Immutable.List(),
  eventsOpen: Immutable.List(),
  handleToogleEventsCards: (event: string) => {},
  handleCloseEventsCards: () => {},
  highlightedId: null,
} as EventContext);

export default Context;
